import useTranslation from '@/hooks/i18n';
import { Link, useLocation } from 'react-router-dom';
import Container from '../Container';
import AnimatedFadeInComponent from '../AnimatedFadeInComponent';

export interface NavigationItem {
  name: string;
  href: string;
  forceActive?: boolean;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

function capitalizeFirstLetter(string?: string) {
  if (!string) return '';
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}

export const NavigationSkeleton = () => {
  return (
    <div className={`animate-pulse`}>
      <Container className={`mt-20`}>
        <div className="col-span-12 flex justify-center gap-4">
          <div className="h-full w-1/5 animate-pulse  bg-gray-300 py-4"></div>
        </div>

        <div className="col-span-12 flex gap-4">
          <div className="h-full w-full animate-pulse  bg-gray-300 py-1"></div>
        </div>
        <div className="col-span-12 flex gap-4">
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
        </div>
      </Container>
    </div>
  );
};

function Navigation({ items }: { items: NavigationItem[]; title: string }) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <AnimatedFadeInComponent>
      <Container addMargin className="!mt-sh-30">
        <div className="col-span-12">
          <div className="border-gray-200">
            <nav
              className="inline-flex h-10 w-full items-center justify-center gap-8 rounded-md text-sh-xxs font-bold"
              aria-label="Tabs">
              {items.map((item) => (
                <Link
                  key={item?.name}
                  to={item.href}
                  className={classNames(
                    item?.forceActive || location.pathname === item.href
                      ? ' border-blue-500 text-foreground shadow-sm'
                      : 'border-transparent text-black-100 hover:border-blue-500 hover:text-blue-500',
                    'cursor-pointer whitespace-nowrap border-b-[2px] py-1 text-sh-xxs font-bold',
                  )}
                  aria-current={location.pathname === item.href ? 'page' : undefined}>
                  {capitalizeFirstLetter(t(item?.name?.toLowerCase()))}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}

export default Navigation;
